// removed by extract-text-webpack-plugin
module.exports = {"container":"js-components-CourseDetails-CourseSection-module__container--3DPJm","empty":"js-components-CourseDetails-CourseSection-module__empty--CAVhE"};